export var SERVER_NAME = "PARDESCO Backoffice";
export var LOGO_URL = "/images/pardercologo.png";
